export default "__VITE_ASSET__B2l2Uxli__"